import m from 'mithril'

/*
Function: removeParam(param[string/array])

Removes any number of parameters from the URL using
the Mithril routing API. The param argument can be 
a single param (string) an array of parameters or nothing.
If the param is left blank, all parameters will be removed.
*/
export const removeParam = param => {
  const url = m.route.get().split('?')
  let newParams = {}

  if (!url[1]) return

  if (param) {
    const tests = typeof param === 'string' ? [param] : param

    const params = new URLSearchParams(url[1])
    newParams = [...params.entries()].reduce((obj, value) => {
      if (tests.indexOf(value[0]) !== -1) return obj
      obj[value[0]] = value[1]
      return obj
    }, {})
  }

  m.route.set(url[0], newParams, { replace: true })
}
